"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const NavAvatarIcon_1 = tslib_1.__importDefault(require("../_InternalComponents/NavAvatarIcon"));
const stringToAvatarLetters_1 = require("../_InternalUtils/stringToAvatarLetters");
const RailIconButton_1 = tslib_1.__importDefault(require("./RailIconButton"));
/**
 *
 * This component is only intended to be used internally in @mnemonic/mui5
 *
 * @internal
 */
const RailItem = (props) => {
    const { icon: iconProp, text, tooltipTitle, TooltipProps, ...restProps } = props;
    const buttonEl = (react_1.default.createElement(RailIconButton_1.default, { "aria-label": text, variant: iconProp ? "icon" : "avatar", ...restProps }, iconProp || react_1.default.createElement(NavAvatarIcon_1.default, { text: (0, stringToAvatarLetters_1.stringToAvatarLetters)(text) })));
    return tooltipTitle || TooltipProps ? (react_1.default.createElement(Tooltip_1.default, { title: tooltipTitle, placement: "right", ...TooltipProps }, buttonEl)) : (buttonEl);
};
exports.default = RailItem;
